// extracted by mini-css-extract-plugin
export default {"btnForm":"ModalEditar_btnForm__+Cfq1"};